<template>
  <div class="attr-topic-item">
    <CompTodoList v-model="value" @onAddItem="handleClickAdd" max="1" :bolDraggable="false">
      <template slot="body" slot-scope="scope">
        <div class="topic-item">
          <el-input
            readonly
            style="width: 150px; margin-right: 10px;"
            v-model="scope.data.price"
            placeholder="标题"
            size="small"
            class="topic-input"
          />
          <div class="topic-item-radio">
            <el-radio-group v-model="scope.data.leftType">
              <el-radio label="left">左对齐</el-radio>
              <el-radio label="right">右对齐</el-radio>
            </el-radio-group>
          </div>
          <div class="topic-item-radio">
            <el-radio-group v-model="scope.data.bg">
              <el-radio label="#FFF">白底</el-radio>
              <el-radio label="#000">黑底</el-radio>
            </el-radio-group>
          </div>
          <div class="topic-item-show">
            <span style="padding-right: 10px;">是否显示:</span>
            <el-switch
              v-model="scope.data.hidden"
              active-color="#155bd4"
              :active-value="true"
              :inactive-value="false"
              inactive-color="">
            </el-switch>
          </div>
          <div class="topic-item-show">
          </div>
        </div>
      </template>
    </CompTodoList>
  </div>
</template>
<script>
import { cloneDeep } from 'lodash'
import Vue from 'vue'
import CompTodoList from '../../comps/comp-todoList'
export default {
  name: 'TopicItem',
  components: {
    CompTodoList
  },
  props: ['value'],
  data() {
    return {}
  },
  created() {
    // this.localValue = cloneDeep(this.value)
  },
  methods: {
    handleClickAdd() {
      this.value.push({
        id: '',
        title: '文本',
        top: Math.floor(Math.random() * (100 - 10 + 1)) + 10,
        left: Math.floor(Math.random() * (100 - 10 + 1)) + 10,
        bg: '#FFF',
        hidden: false,
        leftType: 'left'
      })
    },
    onChangeLink(e, index) {
      const v = cloneDeep(this.value[index])
      Vue.set(this.value, index, {
        ...v,
        ...e
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.attr-topic-item {
  .topic-input {
    width: 220px;
    margin-bottom: 6px;
  }
  .comp-picker-link {
    width: 220px;
  }
  .btn-linkpath {
    max-width: 100%;
  }
  .topic-item-show{
    margin-top: 8px;
  }
}
</style>
